import { Component, OnInit, ViewEncapsulation, OnDestroy, ViewChild, TemplateRef, HostListener } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs';
import { SidebarService, ISidebar } from '../sidebar/sidebar.service';
import { Router } from '@angular/router';
import { LangService, Language } from 'src/app/shared/lang.service';
import { environment } from 'src/environments/environment';
import { getThemeColor, setThemeColor } from 'src/app/utils/util';
import { validate } from 'secure-password-validator';
import { FormsModule } from '@angular/forms';
import { AuthService, GeneralService } from 'src/app/services/services';
import { apiRoutes } from 'src/app/constants/constants';
import { style } from '@angular/animations';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SearchComponent implements OnInit {
  modalRef: BsModalRef;
  config = {  class: 'modal-content modal-md' };
  @ViewChild('template', { static: true }) template: TemplateRef<any>;

  menus:any[]=[];
  searchText: string = ''; // Texto de búsqueda
  objAuthData: any;
  constructor(
    private sidebarService: SidebarService,
    private authService: AuthService,
    private router: Router,
    private langService: LangService,
    private modalService: BsModalService,
    private generalService: GeneralService
  ) {

  }


  async ngOnInit(): Promise<void> {
    this.objAuthData = this.authService.getAuthData();
    this.menus=this.objAuthData.menu.submenus;
  }


  show(): void {
    this.modalRef = this.modalService.show(this.template, this.config);
    const authData = this.authService.getAuthData();
  }


  // Método para filtrar menús
  getfilteredMenus() {
    if (!this.searchText) {
      this.menus = this.objAuthData.menu.submenus;
      return;
    }
  
    this.menus = this.objAuthData.menu.submenus.map(menu => {
      // Filtrar los hijos si el menú tiene hijos
      const filteredHijos = menu.hijos ? menu.hijos.filter(submenu =>
        submenu.nombre.toLowerCase().includes(this.searchText.toLowerCase()) ||
        submenu.ruta.toLowerCase().includes(this.searchText.toLowerCase())
      ) : [];
  
      // Devolver el menú si el nombre o la ruta del menú coincide, o si tiene hijos coincidentes
      if (menu.nombre.toLowerCase().includes(this.searchText.toLowerCase()) ||
          menu.ruta.toLowerCase().includes(this.searchText.toLowerCase()) ||
          filteredHijos.length > 0) {
        return {...menu, hijos: filteredHijos}; // Devuelve el menú con los hijos filtrados
      }
  
      return null; // Si el menú no coincide y no tiene hijos que coincidan, devuelve null
    }).filter(menu => menu !== null); // Filtra los menús nulos
  }

}
